import React, { createContext, useState } from 'react';

export const ContextGlobalFeatures = createContext();

export const ProviderGlobalFeatures = props => {
    const { children } = props;

    const [isLoadingInterface, setIsLoadingInterface] = useState(false);
    const [isExternalPage, setIsExternalPage] = useState(false);

    return (
        <ContextGlobalFeatures.Provider
            value={{
                isLoadingInterface,
                setIsLoadingInterface,
                isExternalPage,
                setIsExternalPage,
            }}
        >
            {children}
        </ContextGlobalFeatures.Provider>
    );
};

export const useInterfaceLoading = () => {
    const ctx = React.useContext(ContextGlobalFeatures);
    if (!ctx)
        throw new Error(
            'useInterfaceLoading must be used within ProviderGlobalFeatures'
        );

    return {
        isLoadingInterface: ctx.isLoadingInterface,
        setIsLoadingInterface: ctx.setIsLoadingInterface,
    };
};
